<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de procedimento consolidado' : 'Cadastro de procedimento consolidado'">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
                
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        
            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/bpa/procedimento-consolidado/components/lancamento/Form'

export default {
    components: { Form },
    methods: {
        handleExit() {
            this.$router.push('/bpa/procedimento-consolidado/index')
        },
        handleSave() {
            this.handleExit()
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>